module.exports = __webpack_public_path__ + "img/goods-5.c6260555.png";